import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'
import LoginRoute from './Login'
import ForgotPasswordRoute from './ForgotPassword'

const Guest = (store) => ({
  path: ROUTE.GUEST,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'guest',
    loadReducer: () => import('./GuestState'),
    loadComponent: () => import('./GuestContainer'),
  }),
  routes: [
    LoginRoute(store),
    ForgotPasswordRoute(store)
  ]
})

export default Guest
